/**
 * Wire formats shared with the Go engine for tool checkpoints and output
 * contracts. Mirrors contentgen-go-backend internal/pipeline/validation/tool.go
 * (contractRefPattern :13, toolNamePattern :17) and types/tool.go — change them
 * together.
 */

/** "<clipstyle>@<version>", version a positive integer. */
export const CONTRACT_REF_PATTERN = /^[A-Za-z][A-Za-z0-9_-]*@[1-9][0-9]*$/;

/** Namespaced sourcing tool wire names: lower-case segments joined by dots ("x.capture"). */
export const TOOL_NAME_PATTERN = /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)*$/;

/** What the engine uses when a tool checkpoint declares no timeout_s (Go DefaultToolTimeoutS). */
export const DEFAULT_TOOL_TIMEOUT_S = 300;

export interface ContractRef {
  style: string;
  version: number;
}

/** Parses "technologyCarousel@1"; null for anything the engine would reject. */
export const parseContractRef = (ref: string | undefined | null): ContractRef | null => {
  const trimmed = (ref || '').trim();
  if (!CONTRACT_REF_PATTERN.test(trimmed)) return null;
  const at = trimmed.lastIndexOf('@');
  return { style: trimmed.slice(0, at), version: Number(trimmed.slice(at + 1)) };
};
